import { PDFDocument } from "pdf-lib";

// Función auxiliar para convertir base64 a ArrayBuffer
function base64ToArrayBuffer(base64) {
  const base64Clean = base64.split(",")[1]; // Elimina el "data:application/pdf;base64," si está
  const binaryString = window.atob(base64Clean);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export async function crearPDF(actas) {
  const mergedPdf = await PDFDocument.create();

  let index = 0;

  for (const acta of actas) {
    if (index > 0) {
      // Agrega una página en blanco entre actas
      mergedPdf.addPage();
    }
    if (acta.acta_fisica?.file) {
      const actaPdfBytes = base64ToArrayBuffer(acta.acta_fisica.file);
      const actaDoc = await PDFDocument.load(actaPdfBytes);
      const actaPages = await mergedPdf.copyPages(actaDoc, actaDoc.getPageIndices());
      actaPages.forEach((p) => mergedPdf.addPage(p)); // primera copia
      actaPages.forEach((p) => mergedPdf.addPage(p)); // segunda copia
    }

    if (acta.aviso?.file) {
      const avisoPdfBytes = base64ToArrayBuffer(acta.aviso.file);
      const avisoDoc = await PDFDocument.load(avisoPdfBytes);
      const avisoPages = await mergedPdf.copyPages(avisoDoc, avisoDoc.getPageIndices());
      avisoPages.forEach((p) => mergedPdf.addPage(p));
    }
    index++;
  }

  const pdfBytes = await mergedPdf.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  window.open(url); // o trigger de descarga automática
}
